{{each lyrics}}
    <p{{ if $index === 0 }} class="aplayer-lrc-current"{{ /if }}>{{$value[1]}}</p>
{{/each}}


// WEBPACK FOOTER //
// ./src/template/lrc.art